import api from 'config/api/protectedApi';
import { apiRoutes } from "config/api/apiRoutes";
import useError from 'utils/useError';
import { IPaginatedList } from 'models/commonModel';
import { ITemplateCreateData, ITemplateLookup, ITemplatesUsageResult, ITemplateUpdateData, IWhatsAppTemplate, TemplateListFilter } from 'models/whatsAppTemplateModel';

export const useWhatsAppTemplateApi = () => {
    const { throwException } = useError()

    async function getWhatsAppPaginatedTemplateList(pageIndex: number, pageSize: number, filter?: TemplateListFilter): Promise<IPaginatedList<IWhatsAppTemplate>> {
        return api.get(apiRoutes.getWhatsAppTemplates, {
            params: {
                pageIndex: pageIndex,
                pageSize: pageSize,
                searchQuery: filter?.searchQuery,
                categoryId: filter?.categoryId,
                languageId: filter?.languageId,
                statusId: filter?.statusId,
            }
        })
            .then(response => response.data)
            .catch(error => {
                throw error
            });
    }

    async function getWhatsAppTemplateLookups(isStaticContent: boolean): Promise<IWhatsAppTemplate[]> {
        return api.get(apiRoutes.getWhatsAppTemplateLookups, {
            params: {
                isStaticContent: isStaticContent
            }
        })
            .then(response => response.data)
            .catch(error => {
                throw error
            });
    }

    async function getWhatsAppTemplate(id: number): Promise<IWhatsAppTemplate> {
        return api.get(apiRoutes.getWhatsAppTemplateById, {
            params: {
                templateId: id
            }
        })
            .then(response => response.data)
            .catch(error => {
                throw error
            });
    }

    async function getTemplateLaguageList(): Promise<ITemplateLookup[]> {
        return api.get(apiRoutes.getTemplateLanguages)
            .then(response => response.data)
            .catch(error => {
                throw error
            });
    }

    async function getTemplateCategoryList(): Promise<ITemplateLookup[]> {
        return api.get(apiRoutes.getTemplateCategories)
            .then(response => response.data)
            .catch(error => {
                throw error
            });
    }

    async function getTemplateStatusList(): Promise<ITemplateLookup[]> {
        return api.get(apiRoutes.getTemplateStatuses)
            .then(response => response.data)
            .catch(error => {
                throw error
            });
    }

    async function createTemplate(data: ITemplateCreateData): Promise<ITemplateCreateData> {
        return api.post(apiRoutes.createTemplate, data)
            .then(() => data)
            .catch(error => {
                throwException(error)
                throw error
            });
    }

    async function updateTemplate(data: ITemplateUpdateData): Promise<ITemplateUpdateData> {
        return api.put(apiRoutes.updateTemplate, data)
            .then(() => data)
            .catch(error => {
                throwException(error)
                throw error
            });
    }

    async function deleteTemplate(templateId: number): Promise<boolean> {
        return api.delete(`${apiRoutes.deleteTemplate}?templateId=${templateId}`)
            .then(() => true)
            .catch(error => {
                throwException(error)
                throw error
            });
    }

    async function syncTemplates() {
        return api.get(apiRoutes.syncTemplate)
            .catch(error => {
                throwException(error)
                throw error
            });
    }

    async function uploadTemplateMediaFile(fileBase64: string, fileName: string, fileMimeType: string): Promise<string> {
        const data = {
            fileBase64: fileBase64,
            fileName: fileName,
            fileMimeType: fileMimeType,
        }
        return api.post(apiRoutes.uploadTemplateMediaType, data)
            .then(response => response.data)
            .catch(error => {
                throw error
            });
    }

    async function getWAUtilityAndMarketingTemplateLookups(isStaticContent: boolean, hasButtons?: boolean): Promise<IWhatsAppTemplate[]> {
        return api.get(apiRoutes.getWAUtilityAndMarketingTemplateLookups, {
            params: {
                isStaticContent: isStaticContent,
                hasButtons: hasButtons
            }
        })
            .then(response => response.data)
            .catch(error => {
                throw error
            });
    }

    async function getWAMediaAndUtilityAndMarketingTemplateLookups(isStaticContent: boolean, hasButtons?: boolean): Promise<IWhatsAppTemplate[]> {
        return api.get(apiRoutes.getWAMediaAndUtilityAndMarketingTemplateLookups, {
            params: {
                isStaticContent: isStaticContent,
                hasButtons: hasButtons
            }
        })
            .then(response => response.data)
            .catch(error => {
                throw error
            });
    }

    async function getIsTemplateUsed(id: number): Promise<boolean> {
        return api.get(apiRoutes.getIsTemplateUsed, {
            params: {
                templateId: id
            }
        })
          .then((response) => {
            return response.data
          })
          .catch((error) => {
            throw error;
          });
      }

      async function getNameWhereTemplateUsed(id: number): Promise<ITemplatesUsageResult> {
        return api.get(apiRoutes.getNameWhereTemplateUsed, {
            params: {
                templateId: id
            }
        })
          .then((response) => {
            return response.data
          })
          .catch((error) => {
            throw error;
          });
      }

    return {
        getWhatsAppPaginatedTemplateList, getWhatsAppTemplateLookups,getWAUtilityAndMarketingTemplateLookups,
        getWhatsAppTemplate, getTemplateLaguageList, getTemplateCategoryList, getTemplateStatusList,
        createTemplate, updateTemplate, deleteTemplate, syncTemplates, uploadTemplateMediaFile, getIsTemplateUsed,getNameWhereTemplateUsed,
        getWAMediaAndUtilityAndMarketingTemplateLookups
    }
}